// Declare the colour of the browser's own chrome for as long as a screen is up.
//
//   useChromeTheme(CHROME.green);                       // always, while mounted
//   useChromeTheme(showOverlay ? CHROME.green : null);  // only while the overlay is
//
// Pass null/undefined to claim nothing — the chrome falls back to whatever
// screen underneath has claimed it, or to the cream default. See
// utils/screenTheme for why this is a stack.
import { useEffect } from 'react';
import { pushChromeTheme, popChromeTheme } from '../utils/screenTheme';

export { CHROME } from '../utils/screenTheme';

/** @param {string|null|undefined} color */
export function useChromeTheme(color) {
  useEffect(() => {
    if (!color) return undefined;
    const token = pushChromeTheme(color);
    return () => popChromeTheme(token);
  }, [color]);
}
